import React from 'react';
import Collapse from '~/components/collapse';
import ContainerFlex from '~/components/containerFlex';
import ProductContainer from '~/views/Consult/User/Detail/components/ProductContainer';
import ProductTabs from '~/views/Consult/User/Detail/components/ProductTabs';

interface CardSectionProps {
  form: Record<string, any>;
  tiposProdutosCartao: string[];
  productTab?: string;
  cards: any[];
  onTabChange: (product: string) => void;
  onOpenCardDropdown: () => void;
  callbackUpdateInvoiceExpiration: () => Promise<void>;
  callbackClickDuplicateCard: () => Promise<void>;
  callbackBlockCard: () => Promise<void>;
}

const CardSection: React.FC<CardSectionProps> = ({
  form,
  tiposProdutosCartao,
  productTab,
  cards,
  onTabChange,
  onOpenCardDropdown,
  callbackUpdateInvoiceExpiration,
  callbackClickDuplicateCard,
  callbackBlockCard,
}) => {
  return (
    <Collapse
      actionOnOpen={onOpenCardDropdown}
      collapseHeight={55}
      title={form.temCarteiraDigital ? '5. Cartão' : '4. Cartão'}
    >
      <ContainerFlex marginLeft={26} marginRight={26}>
        <ProductTabs products={tiposProdutosCartao} onTabChange={onTabChange} />

        <ProductContainer
          cards={cards}
          product={productTab}
          callbackUpdateInvoiceExpiration={callbackUpdateInvoiceExpiration}
          callbackClickDuplicateCard={callbackClickDuplicateCard}
          callbackBlockCard={callbackBlockCard}
        />
      </ContainerFlex>
    </Collapse>
  );
};

export default CardSection;
